export default __webpack_public_path__ + "static/media/N-04.ea5b2dd8.png";